export const FlowProp = Object.freeze({
    StepRows: 'stepRows',
});